import { FaGithub, FaLinkedinIn, FaEnvelope } from "react-icons/fa";
import { profile } from "../data";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div>
            <strong>{profile.name}</strong>
            <span>{profile.role}</span>
          </div>

          <div className="footer-social">
            <a href={profile.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
            <a href={`mailto:${profile.email}`} aria-label="Email">
              <FaEnvelope />
            </a>
          </div>
        </div>

        <p className="footer-copy">© {new Date().getFullYear()} {profile.name}</p>
      </div>
    </footer>
  );
}

export default Footer;
